import styled from '@emotion/styled';

export const SchemeMobilePage = styled.div`
  padding: 0 16px;
`;

export const SchemeProductSection = styled.div`
  position: relative;
`;
export const SchemeMobileLayout = styled.div<{ index: number }>`
  width: 100%;
  display: flex;
  transition: transform 0.5s ease-in-out;
  transform: ${({ index }) => `translateX(-${index * 100}%)`};
`;

export const SchemeMobileCell = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  padding: 16px 0;

  gap: 16px;
`;

export const SchemeMobileCellRight = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  text-align: end;
`;

// 좌우 버튼 레이아웃 (그림자 + hover 수정 포함)
export const SchemeMobileButtonLayout = styled.button<{ position: 'left' | 'right' }>`
  position: absolute;
  top: 250px;
  transform: translateY(-50%);
  background: none;
  border: none;
  padding: 8px;
  z-index: 3;

  width: 40px;
  height: 40px;
  border-radius: 32px;
  background-color: rgba(255, 255, 255, 0.6);

  // ✅ Drop shadow
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);

  ${(props) => (props.position === 'left' ? 'left: 0;' : 'right: 0;')}

  &:hover {
    cursor: pointer;
  }
`;

// ✅ 좌우반전용 Wrapper
export const FlipHorizontal = styled.div`
  transform: scaleX(-1);
`;
